
export function useWorker(fn, successCallback) {
    const code = fn.toString();
    const blob = new Blob(['(' + code + ')()'], { type: 'text/javascript' });
    var worker = new Worker('' + URL.createObjectURL(blob)); //takes in an additional parameter 'options' that's an object. ex: {type: 'module'}
    worker.addEventListener('message', event => successCallback(event)); //event to handle data received from the worker
    return worker;
}